import Swal from 'sweetalert2';

/** Indica si el formulario es inválido. */
export function isTypeFormInvalid(form: { invalid: boolean }): boolean {
  return form.invalid === true;
}

/** Construye payload de tipo de pregunta. */
export function buildTypePayload(value: { regex?: string }): Record<string, unknown> {
  const record = value as Record<string, unknown>;
  return { ...record, regex: normalizeRegex(record['regex']) };
}

/** Normaliza regex vacío a nulo. */
export function normalizeRegex(regex: unknown): string | null {
  if (regex) return regex as string;
  return null;
}

/** Extrae texto de error de API. */
export function typeErrorText(err: { error?: { error?: unknown } }, fallback: string): string {
  return String(err.error?.error ?? fallback);
}

/** Muestra error de guardado. */
export function showTypeError(err: { error?: { error?: unknown } }, fallback: string): void {
  Swal.fire({ icon: 'error', title: 'Error', text: typeErrorText(err, fallback) });
}

/** Pide confirmación de borrado de tipo. */
export function confirmRemoveType(onConfirm: (confirmed: boolean) => void): void {
  Swal.fire({
    title: '¿Seguro?',
    text: 'Se eliminará el tipo de pregunta. Verifica que no esté en uso por algún módulo.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  }).then((result) => onConfirm(result.isConfirmed));
}
